import {Injectable} from '@angular/core';
import {ChatStartService} from '../components/chatbot/chat-start.service';
import {ConversationRessource} from './rest/conversation-ressource.service';

@Injectable({
    providedIn: 'root'
})
export class LearnLearningPackageService {
    constructor(private chatStartService: ChatStartService,
                private conversationService: ConversationRessource) {
    }

    public async learn(learningPackageId: string): Promise<void> {
        this.chatStartService.isWaitingForNotification = true;
        await this.conversationService.selectLearningPackage(learningPackageId);
    }
}
